import Bundle from "../../../entities/manhattan/bundle/Bundle";

export default class BundleFactory {

  create(bundle: Bundle): Bundle {
    return new Bundle(
      bundle.id,
      bundle.identifier,
      bundle.name,
      bundle.productLine,
      bundle.status,
      bundle.bundleProducts
    );
  }

}
